import {
  fuseGetConnectivityConstants,
  fusePostConnectivityConstants,
  // fusePostConnectivityConstants,
  fuseProvisioningDetailConstants,
} from "../_redux-constants";

export function fuseProvisioningDetailReducer(
  state = {
    provisioningDetailLoading: false,
    provisioningDetailData: null,
    provisioningDetailError: null,

    getConnectivityLoading: false,
    getConnectivityData: null,
    getConnectivityError: null,

    postConnectivityLoading: false,
  },
  action
) {
  switch (action.type) {
    case fuseProvisioningDetailConstants.PROVISIONING_DETAIL_LOADING:
      return Object.assign({}, state, {
        provisioningDetailLoading: true,
        provisioningDetailData: null,
        provisioningDetailError: null,
      });
    case fuseProvisioningDetailConstants.PROVISIONING_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        provisioningDetailLoading: false,
        provisioningDetailData: action.data,
        provisioningDetailError: null,
      });
    case fuseProvisioningDetailConstants.PROVISIONING_DETAIL_FAILURE:
      return Object.assign({}, state, {
        provisioningDetailLoading: false,
        provisioningDetailData: null,
        provisioningDetailError: action.error,
      });

    //get remote actions connectivity
    case fuseGetConnectivityConstants.FUSE_CHECK_CONNECTIVITY_LOADING:
      return Object.assign({}, state, {
        getConnectivityLoading: true,
        getConnectivityData: null,
        getConnectivityError: null,
      });
    case fuseGetConnectivityConstants.FUSE_CHECK_CONNECTIVITY_SUCCESS:
      return Object.assign({}, state, {
        getConnectivityLoading: false,
        getConnectivityData: action.data,
        getConnectivityError: null,
      });
    case fuseGetConnectivityConstants.FUSE_CHECK_CONNECTIVITY_FAILURE:
      return Object.assign({}, state, {
        getConnectivityLoading: false,
        getConnectivityData: null,
        getConnectivityError: action.error,
      });

    case fusePostConnectivityConstants.FUSE_POST_CONNECTIVITY_LOADING:
      return Object.assign({}, state, {
        postConnectivityLoading: true,
        // getConnectivityData: null,
        getConnectivityError: null,
      });
    case fusePostConnectivityConstants.FUSE_POST_CONNECTIVITY_SUCCESS:
      return Object.assign({}, state, {
        postConnectivityLoading: false,
        // getConnectivityData: action.data,
        getConnectivityError: null,
      });
    case fusePostConnectivityConstants.FUSE_POST_CONNECTIVITY_FAILURE:
      return Object.assign({}, state, {
        postConnectivityLoading: false,
        // getConnectivityData: null,
        getConnectivityError: action.error,
      });
    default:
      return state;
  }
}
